import { combineReducers } from 'redux';
import { appReducer } from './app/reducer';
import { uiReducer } from './ui/reducer';
import { authentication } from './auth/reducer';
import { msalReducer } from './msal/reducer';
import { conversationReducer } from './conversation/reducer';

const rootReducer = combineReducers({
    appReducer,
    uiReducer,
    authentication,
    msal: msalReducer,
    conversation: conversationReducer,
});

export default rootReducer;
